// extracted by mini-css-extract-plugin
export default {"tooltip-icon":"TooltipIcon_tooltip-icon__aj4I0","tooltip-container":"TooltipIcon_tooltip-container__iJvB5"};